import React from 'react';
import { ChevronDown } from 'lucide-react';
interface HeroSectionProps {
  imageUrl: string;
}
export function HeroSection({
  imageUrl
}: HeroSectionProps) {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-53">
      <div className="absolute inset-0 bg-gradient-to-b from-green-900/20 to-transparent pointer-events-none" data-id="element-54" />

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-55">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black tracking-tight mb-6 text-[#faf5e8] leading-tight" data-id="element-56">
          Cambia los resultados de tus partidos en{' '}
          <span className="text-[#c8e6c9] border-b-4 border-[#c8e6c9]" data-id="element-57">
            8 semanas
          </span>
        </h1>

        <p className="text-xl md:text-2xl text-[#a8c5a8] mb-10 font-medium" data-id="element-58">
          Un sistema diseñado para que domines el juego y no al revés
        </p>

        <div className="relative mx-auto max-w-2xl cursor-pointer transform transition-transform hover:scale-105 duration-300" onClick={scrollToPurchase} style={{
        width: '80%'
      }} data-id="element-59">
          <div className="absolute inset-0 bg-[#4caf50] blur-[100px] opacity-15 rounded-full" data-id="element-60" />
          <img src={imageUrl} alt="Hockey Pro System" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-61" />
        </div>

        <div className="mt-12 flex flex-col items-center" data-id="element-62">
          <button onClick={scrollToPurchase} className="bg-[#2e7d32] hover:bg-[#388e3c] text-[#faf5e8] font-heading font-bold text-xl md:text-2xl py-4 px-10 rounded-full shadow-[0_0_20px_rgba(46,125,50,0.4)] transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(46,125,50,0.6)] uppercase tracking-wide" data-id="element-63">
            Quiero Dominar Mi Juego
          </button>
          <p className="mt-4 text-sm text-[#a8c5a8] flex items-center gap-2" data-id="element-64">
            <ChevronDown className="w-4 h-4 animate-bounce" data-id="element-65" />
            Deslizá para ver más
            <ChevronDown className="w-4 h-4 animate-bounce" data-id="element-66" />
          </p>
        </div>
      </div>
    </section>;
}